
import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface LoginFormFieldsProps {
  email: string;
  setEmail: (value: string) => void;
  password: string;
  setPassword: (value: string) => void;
  loading: boolean;
  handleForgotPassword: () => void;
}

const LoginFormFields: React.FC<LoginFormFieldsProps> = ({
  email,
  setEmail,
  password,
  setPassword,
  loading,
  handleForgotPassword
}) => {
  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="loginEmail">Email</Label>
        <Input
          id="loginEmail"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={loading}
          required
        />
      </div>
      
      <div className="space-y-2">
        <div className="flex justify-between items-center">
          <Label htmlFor="loginPassword">Password</Label>
          <button
            type="button"
            onClick={handleForgotPassword}
            className="text-primary text-xs hover:underline bg-transparent border-none p-0 cursor-pointer"
            disabled={loading}
          >
            Forgot password?
          </button>
        </div>
        <Input
          id="loginPassword"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          disabled={loading}
          required
        />
      </div>
    </>
  );
};

export default LoginFormFields;
